'use client';

import * as React from 'react';
import { Bell, Search } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuth } from '@/lib/auth-context';

interface HeaderProps {
  sidebarCollapsed: boolean;
}

export function Header({ sidebarCollapsed }: HeaderProps) {
  const { user } = useAuth();

  return (
    <header
      className={cn(
        'fixed top-0 right-0 z-30 h-20 bg-white border-b border-gray-100 transition-all duration-300',
        sidebarCollapsed ? 'left-20' : 'left-72'
      )}
    >
      <div className="flex h-full items-center justify-between px-8">
        {/* Search */}
        <div className="flex items-center gap-2 flex-1 max-w-lg">
          <div className="relative w-full">
            <Search className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Buscar clientes, planos, usuarios..."
              className="w-full rounded-xl border border-gray-200 bg-gray-50/50 px-12 py-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0057FF]/20 focus:border-[#0057FF] focus:bg-white transition-all"
            />
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3">
          {/* Notifications */}
          <button className="relative p-3 rounded-xl text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors">
            <Bell className="h-5 w-5" />
            <span className="absolute top-2 right-2 h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-white" />
          </button>

          {/* User */}
          <div className="ml-2 flex items-center gap-4 border-l border-gray-200 pl-6">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-semibold text-gray-900">{user?.name || 'Admin'}</p>
              <p className="text-xs text-gray-500">{user?.email || ''}</p>
            </div>
            <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-[#0057FF] to-[#7C3AED] flex items-center justify-center shadow-lg shadow-[#0057FF]/20 cursor-pointer hover:shadow-xl hover:shadow-[#0057FF]/30 transition-shadow">
              <span className="text-white font-bold">
                {user?.name?.charAt(0).toUpperCase() || 'A'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
